module.exports = __webpack_public_path__ + "img/det_mir.9ed2de2f.png";